import MedicaidRepeatable from '../medicaid-repeatable/medicaid-repeatable.vue';

export default {
  name: 'MedicaidInformation',
  props: ['student', 'medicaidArray', 'showTooltip', 'v'],
  components: {
    MedicaidRepeatable
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    }
  },
  methods: {
    calculateMinutes() {
      let totalReimbursable = 0;
      let total = 0;
      const medicaid = this.student.form.medicaid;
      // loop over medicaid array
      medicaid.forEach((m) => {
        total += Number(m.minutes);
        if (m.procedures && m.procedures.length) {
          for (let i = 0; i < m.procedures.length; i++) {
            if (m.procedures[i].reimbursable) {
              totalReimbursable += Number(m.minutes);
              break;
            }
          }
        }
      });
      this.student.form.totalMedicaidMinutes = total;
      this.student.form.totalReimbursableMinutes = totalReimbursable;
    },
    addMedicaidRecord() {
      this.student.form.medicaid.push(
        {
          minutes: '',
          startTime: '',
          endTime: '',
          procedures: [],
          outcome: ''
        }
      );
    },
    removeMedicaidRecord(index) {
      if (this.student.form.medicaid.length > 1) {
        this.student.form.medicaid.splice(index, 1);
      } else {
        this.student.form.medicaid = [
          {
            minutes: '',
            startTime: '',
            endTime: '',
            procedures: [],
            outcome: ''
          }
        ];
      }
      // recalculate total medicaid minutes
      this.calculateMinutes();
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/service-log/form/medicaid-information/medicaid-information.js